module.exports = __webpack_public_path__ + "img/AquaKiss.8ca21f72.jpg";